import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import App from './App.vue';
import router from './router'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import './tailwind.css'
import './styles/tg-webview-layout.css'
import { initTheme } from './utils/theme'
import { enableTouchZoomGuard } from './utils/touchZoomGuard'

initTheme()
enableTouchZoomGuard()
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import i18n from './i18n';
import 'flag-icon-css/css/flag-icons.css'
// import { loadStripe } from '@stripe/stripe-js';
import TimeService from './utils/timeService';
import { api } from './api';
import { saveUtmParams, collectTrackingData } from './tracking';

// 保存 UTM 参数（用于跨页面追踪广告来源）
saveUtmParams();
// 上报追踪数据 (CAPI)
collectTrackingData();

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.use(i18n)

// 提供 API 服务（按照 Vue 最佳实践）
app.provide('api', api);
app.provide('timeService', TimeService);

// const stripe = loadStripe(process.env.VUE_APP_STRIPE_API_KEY);
// app.provide('stripe', stripe)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.mount('#app');
